import { render, staticRenderFns } from "./PubPriceQuery.vue?vue&type=template&id=e2ebc8a0&scoped=true&"
import script from "./PubPriceQuery.vue?vue&type=script&lang=js&"
export * from "./PubPriceQuery.vue?vue&type=script&lang=js&"
import style0 from "./PubPriceQuery.vue?vue&type=style&index=0&id=e2ebc8a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2ebc8a0",
  null
  
)

export default component.exports